import { ROUTES } from "../utils/RouteConstants";
import {deleteRequest, getRequest, postRequest, putRequest, reportDownloadRequest, doLogin} from "./Api";
import {API_CONSTANTS, REPORT_TYPE, TRANSACTION_TYPES} from "./Constants";
import {FeedbackReducerActionType} from "../utils/FeedbackContext";
import FetchState from "./FetchState";

export async function login(credentials, setFetchState, feedbackDispatch, closeSnackbar, history, location) {
    try {
        const resp = await doLogin("login", credentials);

        if (resp?.message === API_CONSTANTS.SUCCESS) {
            return true;
        }

        setFetchState(null);
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
        return false;

    } catch (e) {
        setFetchState(null);
        return false;
    }
}

export async function getDashboardDetails (setData, setFetchState, feedbackDispatch, closeSnackbar, history, location) {

    const resp = await getRequest("v1/dashboard");

    console.log(resp);

    if (resp.message === API_CONSTANTS.SUCCESS) {

        setData(resp.data);
        setFetchState(FetchState.SUCCESS);

    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
        setFetchState(FetchState.ERROR);
    }
}

export async function getTransactionTypes (setOptions, active, feedbackDispatch, closeSnackbar, history, location){

    const resp = await getRequest("v1/transactionTypes");

    console.log(resp);

    if (resp.message === API_CONSTANTS.SUCCESS) {

        if (active) {
            setOptions(resp.data);
            if (resp.data.length === 0) {
              setOptions([]);
            }
        }

    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
    }
}

export async function getRelationshipTypes(setOptions, active, feedbackDispatch, closeSnackbar, history, location) {

    const resp = await getRequest("v1/relationships");

      console.log(resp);

      if (resp.message === API_CONSTANTS.SUCCESS) {
        if (active) {
          setOptions(resp.data);
          if (resp.data.length === 0) {
            setOptions([]);
          }
        }

      } else {
          handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
      }
}

export async function getMembers (setOptions, active, feedbackDispatch, setFetchState, closeSnackbar, history, location) {

  const resp = await getRequest("v1/members/main");

  console.log(resp);

  if (resp.message === API_CONSTANTS.SUCCESS) {
    if (active) {
      setOptions(resp.data);

      if (resp.data.length === 0) {
        setOptions([]);
      }

      setFetchState(FetchState.SUCCESS);

    }

  } else {
      handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
      setFetchState(FetchState.ERROR);
  }
}

export async function getClaimableMembers(setOptions, active, feedbackDispatch, setFetchState, closeSnackbar, history, location) {

    const resp = await getRequest("v1/members/claimable");

    console.log(resp);

    if (resp.message === API_CONSTANTS.SUCCESS) {
        if (active) {
            setOptions(resp.data);

            if (resp.data.length === 0) {
                setOptions([]);
            }

            setFetchState(FetchState.SUCCESS);

        }

    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
        setFetchState(FetchState.ERROR);
    }
}

export async function getMembersDependants (id, setDependants, feedbackDispatch, setFetchState, closeSnackbar, history, location){

    const resp = await getRequest("v1/members/dependants/" + id);

    console.log(resp);

    if (resp.message === API_CONSTANTS.SUCCESS) {

        setDependants(resp.data);
        setFetchState(FetchState.SUCCESS);

    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
        setFetchState(FetchState.ERROR);
    }
}

export async function getMembersNotes (id, setNotes, feedbackDispatch, setFetchState, closeSnackbar, history, location) {

    let resp = await getRequest("v1/members/notes/" + id);

    if (resp.message === API_CONSTANTS.SUCCESS) {

        setNotes(resp.data);
        setFetchState(FetchState.SUCCESS);

    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
        setFetchState(FetchState.ERROR);
    }
}

export async function addMember (member, feedbackDispatch, closeSnackbar, history, location) {

  console.log(member);

  const resp = await postRequest("v1/members", member);

    if (resp.message === API_CONSTANTS.SUCCESS) {
        feedbackDispatch({
            type: FeedbackReducerActionType.SHOW_FEEDBACK,
            data: {
                severity: "success",
                message: "Successfully Added",
                open: true,
                time: 3000,
                closeType: ((event, reason) => {
                    closeSnackbar && closeSnackbar()
                })
            }
        });

    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
    }
}

export async function editMember (member, id, feedbackDispatch, closeSnackbar, history, location) {

  console.log(member);

  const resp = await putRequest("v1/members/" + id, member);

    if (resp.message === API_CONSTANTS.SUCCESS) {
        feedbackDispatch({
            type: FeedbackReducerActionType.SHOW_FEEDBACK,
            data: {
                severity: "success",
                message: "Successfully Added",
                open: true,
                time: 3000,
                closeType: ((event, reason) => {
                    closeSnackbar && closeSnackbar()
                })
            }
        });

    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
    }
}

export async function deleteMember (id, feedbackDispatch, closeSnackbar, history, location) {

  const resp = await deleteRequest("v1/members/"+id);

    if (resp.message === API_CONSTANTS.SUCCESS) {
        feedbackDispatch({
            type: FeedbackReducerActionType.SHOW_FEEDBACK,
            data: {
                severity: "success",
                message: "Member Deleted",
                open: true,
                time: 3000,
                closeType: ((event, reason) => {
                    closeSnackbar && closeSnackbar()
                })
            }
        });
        return true; // to action within the Promise
    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
    }
}

export async function getDependants(setDependants, active, feedbackDispatch, setFetchState, closeSnackbar, history, location) {

      const resp = await getRequest("v1/dependants");

      console.log(resp);
    
      if (resp.message === API_CONSTANTS.SUCCESS) {

        if (active) {
          setDependants(resp.data);
          if (resp.data.length === 0) {
            setDependants([]);
          }
          setFetchState(FetchState.SUCCESS);
        }

      } else {
          handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
          setFetchState(FetchState.ERROR);
      }
}

export async function addDependant(dependant, member, feedbackDispatch, closeSnackbar, history, location) {

  console.log(dependant);
  
  //convert UI json obj to api request and put
  const data = { 
      ...dependant, 
      relationship: dependant.relationship.id,
      member: member.id
  }

  console.log(data);

  const resp = await postRequest("v1/dependants", data);

  if (resp.message === API_CONSTANTS.SUCCESS) {
    feedbackDispatch({
        type: FeedbackReducerActionType.SHOW_FEEDBACK,
        data: {
            severity: "success",
            message: "Dependant Added",
            open: true,
            time: 3000,
            closeType: ((event, reason) => {
                closeSnackbar && closeSnackbar()
            })
        }
    });
  } else {
      handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
  }
}

export async function updateDependant (dependant, feedbackDispatch, closeSnackbar, history, location) {

    console.log(dependant);

    //convert UI json obj to api request and put
    const data = {
      ...dependant,
      relationship: dependant.relationship.id,
      member: dependant.member.id
    }

    console.log(data);

    const resp = await putRequest("v1/dependants/"+location.state.dependant.id, data);

    if (resp.message === API_CONSTANTS.SUCCESS) {
        feedbackDispatch({
            type: FeedbackReducerActionType.SHOW_FEEDBACK,
            data: {
                severity: "success",
                message: "Dependant Edited",
                open: true,
                time: 3000,
                closeType: ((event, reason) => {
                    closeSnackbar && closeSnackbar()
                })
            }
        });
    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
    }

}

export async function deleteDependant (id, feedbackDispatch, closeSnackbar, history, location) {
  
    const resp = await deleteRequest("v1/dependants/"+id);

    if (resp.message === API_CONSTANTS.SUCCESS) {
        feedbackDispatch({
            type: FeedbackReducerActionType.SHOW_FEEDBACK,
            data: {
                severity: "success",
                message: "Dependant Deleted",
                open: true,
                time: 3000,
                closeType: ((event, reason) => {
                    closeSnackbar && closeSnackbar()
                })
            }
        });

        return true; // this is just to action in the Promise
    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
    }
}

export async function submitInvestment(investment, feedbackDispatch, closeSnackbar, history, location) {

    console.log(investment);

    //convert UI json obj to api request and post
    const data = { 
        ...investment,
        deposit: investment.flag === true  ? true : null,
        withdrawal: investment.flag === false  ? true : null
    }

    console.log(data);

    const resp = await postRequest("v1/investments", data);

    if (resp.message === API_CONSTANTS.SUCCESS) {
        feedbackDispatch({
            type: FeedbackReducerActionType.SHOW_FEEDBACK,
            data: {
                severity: "success",
                message: "Payment Successful",
                open: true,
                time: 3000,
                closeType: ((event, reason) => {
                    closeSnackbar && closeSnackbar()
                })
            }
        });

    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
    }
}

export async function submitCashAtHand(cashAtHand, feedbackDispatch, closeSnackbar, history, location) {

    console.log(cashAtHand);

    //convert UI json obj to api request and post
    const data = {
      ...cashAtHand,
      deposit: cashAtHand.flag === true  ? true : null,
      withdrawal: cashAtHand.flag === false  ? true : null
    }

    console.log(data);

    const resp = await postRequest("v1/cashAtHand", data);

    if (resp.message === API_CONSTANTS.SUCCESS) {
        feedbackDispatch({
            type: FeedbackReducerActionType.SHOW_FEEDBACK,
            data: {
                severity: "success",
                message: "Payment Successful",
                open: true,
                time: 3000,
                closeType: ((event, reason) => {
                    closeSnackbar && closeSnackbar()
                })
            }
        });

    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
    }
}

export async function submitAdhocFund(type, adhocFunds, feedbackDispatch, closeSnackbar, history, location) {

    let resp;
  
    console.log(adhocFunds);
    //convert UI json obj to api request and post
    const data = {
      amount: parseFloat(adhocFunds.amount),
      reason: adhocFunds.reason,
      type : adhocFunds.transactionType.id,
      date: adhocFunds.date,
      eft: adhocFunds.eft
    }

    console.log(data);

    if(TRANSACTION_TYPES.INCOME === type) {
    resp = await postRequest("v1/incomes", data);
    } else if ( TRANSACTION_TYPES.EXPENSE === type) {
    resp = await postRequest("v1/expenses", data);
    }

    if (resp.message === API_CONSTANTS.SUCCESS) {
        feedbackDispatch({
            type: FeedbackReducerActionType.SHOW_FEEDBACK,
            data: {
                severity: "success",
                message: "Payment Successful",
                open: true,
                time: 3000,
                closeType: ((event, reason) => {
                    closeSnackbar && closeSnackbar()
                })
            }
        });

    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
    }
}

export async function submitPremium(premium, feedbackDispatch, closeSnackbar, history, location) {

  console.log(premium);
  //convert UI json obj to api request and post
  const data = {
      amount: premium.amount,
      date: premium.date,
      id: premium.member.id,
      eft: premium.eft
  }

  console.log(data);
  const resp = await postRequest("v1/premiums", data);

    if (resp.message === API_CONSTANTS.SUCCESS) {
        feedbackDispatch({
            type: FeedbackReducerActionType.SHOW_FEEDBACK,
            data: {
                severity: "success",
                message: "Payment Successful",
                open: true,
                time: 3000,
                closeType: ((event, reason) => {
                    closeSnackbar && closeSnackbar()
                })
            }
        });

    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
    }
}

export async function submitClaim(claim, feedbackDispatch, closeSnackbar, history, location) {

  let resp;
  
  console.log(claim);
  //convert UI json obj to api request and post
  const data = {
      id: claim.id.id,
      amount: claim.amount,
      claimDate: claim.claimDate,
      buriedDate: claim.buriedDate,
      deathDate: claim.deathDate,
      burialPlace : claim.burialPlace
  }

  console.log(data);

    resp = await postRequest("v1/claims", data);

    if (resp.message === API_CONSTANTS.SUCCESS) {
        feedbackDispatch({
            type: FeedbackReducerActionType.SHOW_FEEDBACK,
            data: {
                severity: "success",
                message: "Payment Successful",
                open: true,
                time: 3000,
                closeType: ((event, reason) => {
                    closeSnackbar && closeSnackbar()
                })
            }
        });
    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
    }

}

export async function addNote(note, member, feedbackDispatch, closeSnackbar, history, location) {

    console.log(note);

    //convert UI json obj to api request and post
    const data = {
        note: note,
        member: member.id
    }

    console.log(data);

    const resp = await postRequest("v1/notes", data);

    if (resp.message === API_CONSTANTS.SUCCESS) {
        feedbackDispatch({
            type: FeedbackReducerActionType.SHOW_FEEDBACK,
            data: {
                severity: "success",
                message: "Note Added",
                open: true,
                time: 3000,
                closeType: ((event, reason) => {
                    closeSnackbar && closeSnackbar()
                })
            }
        });
    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
    }
}

export async function editNote(note, member, feedbackDispatch, closeSnackbar, history, location) {

    let resp;

    console.log(note);
    //convert UI json obj to api request and post
    const data = {
        note: note,
        member: member.id
    }

    console.log(data);

    resp = await putRequest("v1/notes/"+location.state.note.id, data);

    if (resp.message === API_CONSTANTS.SUCCESS) {
        feedbackDispatch({
            type: FeedbackReducerActionType.SHOW_FEEDBACK,
            data: {
                severity: "success",
                message: "Note Edited",
                open: true,
                time: 3000,
                closeType: ((event, reason) => {
                    closeSnackbar && closeSnackbar()
                })
            }
        });
    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
    }

}

export async function memberTransactionList(request, setTransactions, feedbackDispatch, closeSnackbar, history, location) {

    console.log(request);

    const data = {id: request.member.id, date: request.date}

    const resp = await postRequest("v1/query/transactionHistory", data);

    if (resp.message === API_CONSTANTS.SUCCESS) {

        setTransactions(resp.data);

    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
    }
}

export async function getMemberBalance (id, setMemberBalance, feedbackDispatch, closeSnackbar, history, location) {

    const resp = await getRequest("v1/members/balance/" + id);

    if (resp.message === API_CONSTANTS.SUCCESS) {
        setMemberBalance(resp.data);
    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
    }
}

export async function downloadReport(reportType, feedbackDispatch, closeSnackbar, history, location) {

    let resp;
    let fileName;
    const date = new Date();

    if(REPORT_TYPE.CLAIMS === reportType) {
        resp = await reportDownloadRequest("v1/reports/claims");
        fileName = "REPORT Claims " + date.toDateString() +".csv"

    } else if(REPORT_TYPE.MEMBER_DETAILS === reportType) {
        resp = await reportDownloadRequest("v1/reports/memberDetails");
        fileName = "REPORT Member Dump " + date.toDateString() +".csv"
    }

    if (resp.message === API_CONSTANTS.SUCCESS) {

        feedbackDispatch({
            type: FeedbackReducerActionType.SHOW_FEEDBACK,
            data: {
                severity: "success",
                message: "Report Downloaded",
                open: true,
                time: 3000,
                closeType: ((event, reason) => {
                    closeSnackbar && closeSnackbar()
                })
            }
        });

        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
    }
}

export async function emailReport(reportType, email, feedbackDispatch, closeSnackbar, history, location) {

    let resp;

    if(REPORT_TYPE.CLAIMS === reportType) {
        resp = await reportDownloadRequest("v1/reports/claims/" + email);

    } else if(REPORT_TYPE.MEMBER_DETAILS === reportType) {
        resp = await reportDownloadRequest("v1/reports/memberDetails/" + email);
    }

    if (resp.message === API_CONSTANTS.SUCCESS) {

        feedbackDispatch({
            type: FeedbackReducerActionType.SHOW_FEEDBACK,
            data: {
                severity: "success",
                message: "Report Emailed Successfully",
                open: true,
                time: 3000,
                closeType: ((event, reason) => {
                    closeSnackbar && closeSnackbar()
                })
            }
        });

    } else {
        handleFailureUserFeedback(resp, feedbackDispatch, closeSnackbar, history, location);
    }
}



const handleFailureUserFeedback = (resp, feedbackDispatch, closeSnackbar, history, location) => {

    let message;

    if (resp.message === API_CONSTANTS.FAILURE) {
        message = resp.error;

    } else if (resp.message === API_CONSTANTS.UNAUTHORIZED) {
        history.push(ROUTES.LOGIN, { last: location.pathname, data: location.state });
        return;

    } else if (resp.message === API_CONSTANTS.NO_CONNECTION) {
        message = "Check your internet connection";

    } else if (resp.message === API_CONSTANTS.TIMEOUT) {
        message = "Request timed out. Please Try Again";

    } else if (resp.message === API_CONSTANTS.SERVER_ERROR) {
        message = "Unknown Error - Please contact the developer";
    }

    feedbackDispatch({
        type: FeedbackReducerActionType.SHOW_FEEDBACK,
        data: {
            severity: "error",
            message: message,
            open: true,
            time: 6000,
            closeType: ((event, reason) => {
                closeSnackbar && closeSnackbar()
            })
        }
    });
}